const G = 150;
const rnd = (i, k) => { const v = Math.sin(i * 12.9898 + k * 78.233) * 43758.5453; return v - Math.floor(v); };

export const SEASONS = ["winter", "spring", "summer", "fall"];
export const seasonOf = (d = new Date()) => ["winter", "winter", "spring", "spring", "spring", "summer", "summer", "summer", "fall", "fall", "fall", "winter"][d.getMonth()];

export const PALETTE = {
  winter: { sky: ["#8FA9C4", "#C3D4E4", "#EDF2F7"], ground: "#F1F4F7", edge: "#D3DDE6", hill: "#E2E9F0", pine: ["#2F5E45", "#3C7257"], sun: "#FFF3C9", cloud: "#F3F6F9" },
  spring: { sky: ["#63B1F0", "#A5D6FA", "#E6F6FF"], ground: "#9DDB7F", edge: "#74C35E", hill: "#B9E6A0", pine: ["#2E7048", "#3E8A5A"], sun: "#FFD84D", cloud: "#FFFFFF" },
  summer: { sky: ["#2C8BE6", "#6FBAF5", "#CBEAFF"], ground: "#8FD07A", edge: "#6DB85B", hill: "#A9DB8C", pine: ["#285F3D", "#367A4F"], sun: "#FFC93D", cloud: "#FFFFFF" },
  fall: { sky: ["#6F9CD3", "#EBC08F", "#FBE2C0"], ground: "#C8B35A", edge: "#A8943E", hill: "#D8B66A", pine: ["#2D5A3E", "#3B6E4E"], sun: "#FFB347", cloud: "#FFF7EC" },
};

export function Pine({ x, h = 40, snow, tone }) {
  const tiers = [0, 1, 2].map((i) => { const base = G - 3 - i * h * 0.24; const w = h * 0.3 * (1 - i * 0.24); return { base, w, top: base - h * 0.42 }; });
  return (
    <g data-testid="scene-pine">
      <rect x={x - 1.6} y={G - 6} width="3.2" height="6" fill="#6B4A2E" />
      {tiers.map((t, i) => <path key={i} d={`M${x - t.w} ${t.base} L${x} ${t.top} L${x + t.w} ${t.base} Z`} fill={i % 2 ? tone[1] : tone[0]} />)}
      {snow && tiers.map((t, i) => <path key={`s${i}`} d={`M${x - t.w * 0.42} ${t.top + h * 0.18} L${x} ${t.top} L${x + t.w * 0.42} ${t.top + h * 0.18} Q${x} ${t.top + h * 0.13} ${x - t.w * 0.42} ${t.top + h * 0.18} Z`} fill="#fff" />)}
    </g>
  );
}

export const PINES = [[-290, 46], [-262, 34], [-236, 52], [-200, 30], [-168, 44], [-120, 38], [-92, 54], [-58, 32], [-26, 42], [6, 30], [110, 26], [126, 36], [212, 28], [292, 34], [436, 44], [452, 30]];

function Pot({ x, y, c = "#C8754B", leaf = "#3E9B54", s = 1, flower }) {
  return (
    <g transform={`translate(${x} ${y}) scale(${s})`}>
      <circle cx="-3" cy="-7" r="3.6" fill={leaf} /><circle cx="3" cy="-8" r="4" fill={leaf} /><circle cx="0" cy="-11" r="3.6" fill={leaf} opacity="0.9" />
      {flower && <><circle cx="-2.5" cy="-11" r="1.4" fill={flower} /><circle cx="3" cy="-12" r="1.4" fill={flower} /></>}
      <path d="M-4.5 -5 h9 l-1.2 5 h-6.6 Z" fill={c} />
    </g>
  );
}

export function GreenhousePlants() {
  return (
    <g data-testid="scene-greenhouse-plants">
      <path d="M312 150 C310 128 304 112 298 104 C306 110 312 120 314 132 C314 116 318 100 326 90 C322 104 318 122 318 150 Z" fill="#2F8A4A" />
      <path d="M380 150 C382 130 388 116 392 108 C386 112 382 122 380 132 C379 118 374 104 366 96 C372 108 376 124 376 150 Z" fill="#2F8A4A" />
      <path d="M345 66 V80 M322 76 V86 M368 76 V86" stroke="#7A5A3A" strokeWidth="0.7" />
      {[[345, 84], [322, 90], [368, 90]].map(([x, y], i) => (
        <g key={i}><path d={`M${x - 5} ${y} h10 l-2 4 h-6 Z`} fill="#A0673F" />
          <path d={`M${x - 4} ${y + 3} q-2 6 0 11 M${x + 4} ${y + 3} q2 7 -1 12 M${x} ${y + 4} q1 5 -1 9`} stroke="#3E9B54" strokeWidth="1.6" fill="none" strokeLinecap="round" />
          <circle cx={x - 3} cy={y - 1} r="3" fill="#4CAF62" /><circle cx={x + 3} cy={y - 1.5} r="3" fill="#3E9B54" /></g>
      ))}
      <rect x="302" y="121" width="30" height="2" rx="1" fill="#9C7A55" /><rect x="358" y="121" width="30" height="2" rx="1" fill="#9C7A55" />
      <Pot x={308} y={121} s={0.8} flower="#FF6B9A" /><Pot x={318} y={121} s={0.75} leaf="#5DBB63" /><Pot x={327} y={121} s={0.8} flower="#FFD23F" />
      <Pot x={363} y={121} s={0.8} leaf="#5DBB63" flower="#B38CFF" /><Pot x={373} y={121} s={0.75} /><Pot x={383} y={121} s={0.8} flower="#FF8A3D" />
      <Pot x={307} y={150} s={1.15} leaf="#3E9B54" /><Pot x={324} y={150} s={1} flower="#FF6B9A" /><Pot x={366} y={150} s={1} leaf="#5DBB63" /><Pot x={383} y={150} s={1.15} flower="#FFD23F" />
    </g>
  );
}

const along = (n, f) => Array.from({ length: n }, (_, i) => f(i / (n - 1), i));
const eave = (t) => (t < 0.5 ? [300 + 90 * t, 92 - 64 * t] : [300 + 90 * t, 60 + 64 * (t - 0.5)]);

function Lights({ reduce }) {
  const cols = ["#FF453A", "#30D158", "#FFD60A", "#0A84FF"];
  return (
    <g data-testid="scene-lights">
      <path d="M300 93 L345 61 L390 93" stroke="#2B2B2B" strokeWidth="0.6" fill="none" />
      {along(15, (t, i) => { const [x, y] = eave(t); return (
        <circle key={i} cx={x} cy={y + 2.4} r="1.6" fill={cols[i % 4]}>
          {!reduce && <animate attributeName="opacity" values="1;0.35;1" dur="1.4s" begin={`${(i % 3) * 0.45}s`} repeatCount="indefinite" />}
        </circle>
      ); })}
    </g>
  );
}

function Bunting({ colors }) {
  return (
    <g data-testid="scene-bunting">
      <path d="M300 93 Q345 103 390 93" stroke="#8E8E93" strokeWidth="0.6" fill="none" />
      {along(9, (t, i) => { const x = 300 + 90 * t; const y = 93 + 10 * 4 * t * (1 - t) * 0.5 + 0.5; return i < 8 && <path key={i} d={`M${x + 1} ${y} h8 l-4 7 Z`} fill={colors[i % colors.length]} />; })}
    </g>
  );
}

function Pumpkin({ x, s = 1, face }) {
  return (
    <g transform={`translate(${x} ${G}) scale(${s})`} data-testid="scene-pumpkin">
      <ellipse cx="-3" cy="-5" rx="4.5" ry="5" fill="#E8731C" /><ellipse cx="3" cy="-5" rx="4.5" ry="5" fill="#E8731C" /><ellipse cx="0" cy="-5" rx="4" ry="5.4" fill="#F48A2A" />
      <path d="M0 -10 q1 -3 3 -3.5" stroke="#4E7A2C" strokeWidth="1.4" fill="none" strokeLinecap="round" />
      {face && <path d="M-3 -7 l1.2 -1.8 l1.2 1.8 Z M1 -7 l1.2 -1.8 l1.2 1.8 Z M-3 -3.5 q3 2 6 0 l-1 0.4 l-1 -0.8 l-1 0.8 l-1 -0.8 l-1 0.8 Z" fill="#5A2A08" />}
    </g>
  );
}

function Flowers({ x0, n, colors, h = 8 }) {
  return along(n, (t, i) => { const x = x0 + i * 5; return (
    <g key={i}><path d={`M${x} ${G} V${G - h - (i % 2) * 2}`} stroke="#3E9B54" strokeWidth="1.1" />
      <ellipse cx={x} cy={G - h - (i % 2) * 2 - 1.5} rx="1.9" ry="2.4" fill={colors[i % colors.length]} /></g>
  ); });
}

function Sunflower({ x, h }) {
  return (
    <g data-testid="scene-sunflower">
      <path d={`M${x} ${G} V${G - h}`} stroke="#4E8A33" strokeWidth="1.6" /><path d={`M${x} ${G - h * 0.45} q-6 -3 -8 1 q5 2 8 -1`} fill="#4E8A33" />
      {along(10, (t, i) => { const a = i * 0.628; return <ellipse key={i} cx={x + Math.cos(a) * 4} cy={G - h + Math.sin(a) * 4} rx="2.4" ry="1.3" transform={`rotate(${(a * 180) / Math.PI} ${x + Math.cos(a) * 4} ${G - h + Math.sin(a) * 4})`} fill="#FFC21A" />; })}
      <circle cx={x} cy={G - h} r="3" fill="#6B3E1A" />
    </g>
  );
}

export function Decor({ season, reduce, october, wreath = true }) {
  if (season === "winter") return (
    <g data-testid="scene-decor-winter">
      <path d="M297 94 L345 58 L393 94 L389 96 L345 64 L301 96 Z" fill="#fff" />
      <path d="M77 126 L97 111 L117 126 L114 127.5 L97 115 L80 127.5 Z" fill="#fff" />
      <Lights reduce={reduce} />
      {wreath && <g data-testid="scene-wreath"><circle cx="345" cy="108" r="4.6" fill="none" stroke="#2F7A45" strokeWidth="2.6" /><path d="M343 112 l2 -2 l2 2 l-2 1 Z" fill="#E0242B" />{[0, 1.6, 3.4, 4.8].map((a) => <circle key={a} cx={345 + Math.cos(a) * 4.6} cy={108 + Math.sin(a) * 4.6} r="0.9" fill="#E0242B" />)}</g>}
    </g>
  );
  if (season === "spring") return (
    <g data-testid="scene-decor-spring">
      <Bunting colors={["#FF9EC4", "#FFE27A", "#9AD8FF", "#B9F2A1", "#D7B8FF"]} />
      <Flowers x0={176} n={4} colors={["#FF6B9A", "#FFD23F", "#B38CFF"]} /><Flowers x0={284} n={3} colors={["#FF6B9A", "#FFFFFF"]} />
    </g>
  );
  if (season === "summer") return (
    <g data-testid="scene-decor-summer">
      <Bunting colors={["#FF453A", "#FFFFFF", "#0A84FF", "#FFD60A"]} />
      <Sunflower x={288} h={34} /><Sunflower x={296} h={42} /><Sunflower x={128} h={30} />
    </g>
  );
  return (
    <g data-testid="scene-decor-fall">
      <g data-testid="scene-garland">{along(13, (t, i) => { const [x, y] = eave(t); return <ellipse key={i} cx={x} cy={y + 2.2} rx="2.4" ry="1.4" transform={`rotate(${i * 37} ${x} ${y + 2.2})`} fill={["#D9481C", "#F08A24", "#E8B100"][i % 3]} />; })}</g>
      <rect x="370" y="141" width="16" height="9" rx="1.5" fill="#E2C266" /><path d="M370 145 h16 M372 141 v9 M384 141 v9" stroke="#C9A548" strokeWidth="0.7" />
      <Pumpkin x={327} face={october} /><Pumpkin x={362} s={0.8} /><Pumpkin x={378} s={0.7} />
    </g>
  );
}

export function Weather({ season, reduce, top }) {
  const fall = G - top;
  if (season === "winter") return (
    <g data-testid="scene-snow">
      {Array.from({ length: 70 }, (_, i) => { const x = -340 + rnd(i, 1) * 760; const d = 7 + rnd(i, 2) * 6; return (
        <circle key={i} cx={x} cy={reduce ? top + rnd(i, 3) * fall : top} r={0.8 + rnd(i, 4) * 1.4} fill="#fff" opacity={0.7 + rnd(i, 5) * 0.3}>
          {!reduce && <animateTransform attributeName="transform" type="translate" values={`0 0;${(rnd(i, 6) - 0.5) * 30} ${fall}`} dur={`${d}s`} begin={`-${rnd(i, 7) * d}s`} repeatCount="indefinite" />}
        </circle>
      ); })}
    </g>
  );
  if (season === "fall") return (
    <g data-testid="scene-leaves">
      {Array.from({ length: 22 }, (_, i) => { const x = -320 + rnd(i, 1) * 720; const d = 8 + rnd(i, 2) * 6; const y = reduce ? top + rnd(i, 3) * fall : top; return (
        <g key={i}>{!reduce && <animateTransform attributeName="transform" type="translate" values={`0 0;${30 + rnd(i, 4) * 30} ${fall * 0.5};${10 + rnd(i, 5) * 40} ${fall}`} dur={`${d}s`} begin={`-${rnd(i, 6) * d}s`} repeatCount="indefinite" />}
          <path d={`M${x} ${y - 2.6} Q${x + 2.6} ${y} ${x} ${y + 2.6} Q${x - 2.6} ${y} ${x} ${y - 2.6} Z`} fill={["#D9481C", "#F08A24", "#E8B100", "#B5361A"][i % 4]}>
            {!reduce && <animateTransform attributeName="transform" type="rotate" values={`0 ${x} ${y};360 ${x} ${y}`} dur={`${2 + rnd(i, 7) * 2}s`} repeatCount="indefinite" />}
          </path></g>
      ); })}
    </g>
  );
  if (season === "spring") return (
    <g data-testid="scene-spring-sky">
      <g opacity="0.42" data-testid="scene-rainbow">{["#FF5E57", "#FFA23A", "#FFE45C", "#62D26F", "#4FA8FF", "#9D7BFF"].map((c, i) => <path key={c} d={`M${150 + i * 3.4} ${G} A${78 - i * 3.4} ${78 - i * 3.4} 0 0 1 ${306 - i * 3.4} ${G}`} stroke={c} strokeWidth="3.4" fill="none" />)}</g>
      {!reduce && Array.from({ length: 34 }, (_, i) => { const x = -300 + rnd(i, 1) * 700; return (
        <path key={i} d={`M${x} ${top} l-1.4 6`} stroke="#7FB2E5" strokeWidth="1" strokeLinecap="round" opacity="0">
          <animate attributeName="opacity" values="0.8;0.8" dur="0.9s" begin={`${rnd(i, 2) * 0.9}s`} repeatCount="indefinite" />
          <animateTransform attributeName="transform" type="translate" values={`0 0;-8 ${fall}`} dur="0.9s" begin={`${rnd(i, 2) * 0.9}s`} repeatCount="indefinite" />
        </path>
      ); })}
    </g>
  );
  return (
    <g data-testid="scene-birds">
      {[[0, 0, 16], [14, 8, 19], [26, -4, 22]].map(([dx, dy, d], i) => (
        <path key={i} d={`M${-300 + dx} ${top + 40 + dy} q3 -3 6 0 q3 -3 6 0`} stroke="#33475B" strokeWidth="1.1" fill="none" strokeLinecap="round">
          {!reduce && <animateTransform attributeName="transform" type="translate" values="0 0;760 -10" dur={`${d}s`} begin={`-${i * 3}s`} repeatCount="indefinite" />}
        </path>
      ))}
    </g>
  );
}

export function Kit({ season }) {
  if (season !== "winter") return null;
  return (
    <g data-testid="scene-winter-kit">
      <path d="M-8 -41 Q-8 -50.5 0 -50.5 Q8 -50.5 8 -41 Z" fill="#2E6FD1" /><rect x="-8.6" y="-42.5" width="17.2" height="3" rx="1.4" fill="#fff" /><circle cx="0" cy="-51.5" r="2.2" fill="#fff" />
      <rect x="-6.5" y="-32.4" width="13" height="3.2" rx="1.5" fill="#E0242B" /><rect x="2" y="-31" width="3" height="7" rx="1.2" fill="#E0242B" />
    </g>
  );
}

export function Greenhouse({ x, s = 1, color, id, children }) {
  const house = `M300 ${G} V92 L345 60 L390 92 V${G} Z`;
  return (
    <g transform={`translate(${x - 300 * s} ${G - G * s}) scale(${s})`} data-testid="mini-greenhouse">
      <defs><linearGradient id={id} x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#fff" stopOpacity="0.6" /><stop offset="1" stopColor={color} stopOpacity="0.16" /></linearGradient></defs>
      <path d={house} fill={`url(#${id})`} />
      <GreenhousePlants />
      <path d={house} fill="#fff" fillOpacity="0.14" stroke={color} strokeWidth="3" strokeLinejoin="round" />
      <path d={`M345 60 V116 M300 92 H390 M322 76 V${G} M368 76 V${G}`} stroke={color} strokeOpacity="0.35" strokeWidth="1.6" />
      <rect x="334" y="116" width="22" height={G - 116} rx="2" fill="hsl(var(--background))" stroke={color} strokeWidth="2.4" />
      {children}
    </g>
  );
}
